import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import('@/views/StoreHome.vue'),
  //   meta: {
  //     title: 'eBay-store'
  //   }
  // },
  // {
  //   path: '/',
  //   // path: '/head',
  //   name: 'header',
  //   component: () => import('@/components/StoreHead.vue'),
  //   meta: {
  //     title: 'store-head'
  //   }
  // },
  {
    path: '/',
    // path: '/body',
    name: 'body',
    // redirect: "/home",
    component: () => import('@/components/StoreBody.vue'),
    meta: {
      title: 'store-body'
    }
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  // base: '/FR/fr-head/',//基础路径,要写服务器的路径
  routes
})

export default router
